import { ROUTES } from "@constants/routes";
import { IconReceiptCheck } from "@pentabd/icons";
import { Header } from "@pentabd/ui";
import { PackageCreateType } from "@type/procurements/package";
import { useTranslation } from "react-i18next";

export default function AddNewPackageHeader({
  data,
}: {
  data: PackageCreateType | null;
}) {
  const { t } = useTranslation();
  const breadcrumbs = [
    {
      icon: <IconReceiptCheck fill="dark" size="20" />,
    },
    {
      link: ROUTES.PROCUREMENT.ANNUAL_PROCUREMENT_PLAN,
      label: t("PROCUREMENT_ADD_PACKAGE.BREADCRUMBS.FIRST_STEP"),
    },
    {
      label: data
        ? data.title
        : t("PROCUREMENT_ADD_PACKAGE.BREADCRUMBS.THIRD_STEP"),
    },
  ];

  const headerText = {
    header: data ? data.title : t("PROCUREMENT_ADD_PACKAGE.LABEL"),
  };

  return <Header headerText={headerText} breadcrumbs={breadcrumbs} />;
}
